// extracted by mini-css-extract-plugin
export default {"seo-data":"_1HW0T","seoData":"_1HW0T"};